import { SessionSubscriber } from '../sessionTracker';
import { ClientSession } from '../sessionTracker.domain';
let _session: ClientSession;
let _lastSyncId = 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const prepareValue = (id: number, v: any) => {
  try {
    return JSON.stringify(v);
  } catch (err) {
    console.log('cannot prepare value, event id:', id);
    return '';
  }
};
const PB_API_URL = `${import.meta.env.VITE_LANDING_PAGE_URL}/api/v2`;
const syncSession = async () => {
  const events = _session.events.filter((e) => e.meta.id > _lastSyncId);
  if (!events.length) return;
  // console.log('Syncing session:', events);
  try {
    const message = events.map(
      (e) =>
        `${e.type} (${e.meta.id}), ${prepareValue(e.meta.id, e.value)}}, ${
          e.meta.pathname
        }, ${e.meta.date}`,
    );

    const reqPrefix = `sid:${_session.sessionId}, ${_session.createdAt}, ${_session.url}`;
    const optPrefix = _session.userEmail
      ? `, email:${_session.userEmail}`
      : '' + _session.influencerId
      ? `, iid:${_session.influencerId}`
      : '';
    const body = {
      prefix: `${reqPrefix}${optPrefix}`,
      message,
      ua: navigator.userAgent,
    };
    await fetch(`${PB_API_URL}/log`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    _lastSyncId = events[events.length - 1].meta.id;
  } catch (err) {
    console.error('Failed to sync session:', err);
  }
};
export const openSearchSessionSubscriber: SessionSubscriber = {
  name: 'SessionSubscriber.OpenSearch',
  onInit: (session) => {
    _session = session;
    setInterval(syncSession, 30 * 1000);
  },
  onEvent: (_) => {
    // console.log('Event:', event);
  },
  sync: syncSession,
};
